import React, { useState } from 'react';
import emptyImage from '../../../../assets/images/empty-image.svg';
import ProductItem from '../../../../shared/components/ProductItem/Index';
import { PRODUCT } from '../../../types/productType';

export default function Index(_) {
    const [mockProducts] = useState([
        {
            id: "01",
            oldPrice: 0,
            price: 0,
            productType: PRODUCT,
            images: [emptyImage]
        },
        {
            id: "02",
            oldPrice: 0,
            price: 0,
            productType: PRODUCT,
            images: [emptyImage]
        },
        {
            id: "03",
            oldPrice: 0,
            price: 0,
            productType: PRODUCT,
            images: [emptyImage]
        },
        {
            id: "04",
            oldPrice: 0,
            price: 0,
            productType: PRODUCT,
            images: [emptyImage]
        },
        {
            id: "05",
            oldPrice: 0,
            price: 0,
            productType: PRODUCT,
            images: [emptyImage]
        },
        {
            id: "06",
            oldPrice: 0,
            price: 0,
            productType: PRODUCT,
            images: [emptyImage]
        }
    ]);
    return (
        <div className="row">
            {
                mockProducts.map(item => <ProductItem key={item.id} item={item} columns={3} />)
            }
        </div>
    );
}